import { createFlagsScheme, schema } from '@funtech-int/yango-shared';
import type { RemoteConfig } from '@funtech-int/yango-shared';
import type { Scenario } from '@funtech-int/rival';

import { clientConfig } from '@/config/client';

const TOGGLEABLE_SCENARIOS = {
    crunchyroll: schema.boolean.optional(false),
    sport: schema.boolean.optional(false),
    channels: schema.boolean.optional(false),
};

type ToggleableKey = keyof typeof TOGGLEABLE_SCENARIOS;

export type ScenariosConfig = Partial<Record<ToggleableKey, boolean>>;

export const remoteConfigScheme = createFlagsScheme({
    header_items: schema.arrayOf(schema.string).optional(),
    legal: schema.arrayOf(schema.create({ id: schema.string, link: schema.string })).optional(),
    support_links: schema.mapOf(schema.string).optional(clientConfig.clientSupportLinks),
    onboarding_config: schema
        .create({ isYasminaInfoBlockEnabled: schema.boolean.optional() })
        .optional(),
    scenarios_config: schema.create(TOGGLEABLE_SCENARIOS).optional(),
});

export function getScenariosConfig(remoteConfig: RemoteConfig): ScenariosConfig | undefined {
    return remoteConfigScheme.apply(remoteConfig.flags).get('scenarios_config');
}

export function filterScenariosBy(
    config: ScenariosConfig | undefined,
    scenarios: Record<string, Scenario | undefined>
): Scenario[] {
    return Object.entries(scenarios).reduce<Scenario[]>((enabled, [key, scenario]) => {
        const toggleable = key in TOGGLEABLE_SCENARIOS;
        const disabled = toggleable && !config?.[key as ToggleableKey];

        if (scenario && !disabled) {
            enabled.push(scenario);
        }

        return enabled;
    }, []);
}
